// Debug helper specifically for subscription issues
export const debugSubscription = {
  logSellingPlanSearch(variantId, frequency, plans) {
    console.group('🔍 Selling Plan Search');
    console.log('Variant ID:', variantId);
    console.log('Frequency:', frequency);
    console.log('Available Plans:', plans);
    plans?.forEach(plan => {
      console.log(`Plan: ${plan.name} (${plan.id})`);
      plan.options?.forEach(opt => {
        console.log(`  - ${opt.name}: ${opt.value}`);
      });
    });
    console.groupEnd();
  },

  logCartLine(line) {
    console.group('📦 Cart Line for Subscription');
    console.log('Line object:', line);
    console.log('Has sellingPlanId?', !!line.sellingPlanId);
    console.log('sellingPlanId value:', line.sellingPlanId);
    console.groupEnd();
  },

  logMutation(mutation, variables) {
    console.group('🚀 GraphQL Mutation');
    console.log('Mutation:', mutation);
    console.log('Variables:', JSON.stringify(variables, null, 2));
    console.groupEnd();
  },

  logResponse(response) {
    console.group('✅ Cart Response');
    console.log('Response:', response);
    if (response?.cartLinesAdd?.cart?.lines?.edges) {
      response.cartLinesAdd.cart.lines.edges.forEach(edge => {
        const node = edge.node;
        console.log(`Item: ${node.merchandise.product?.title}`);
        console.log(`  - Has selling plan?`, !!node.sellingPlanAllocation);
        console.log(`  - Selling plan:`, node.sellingPlanAllocation?.sellingPlan);
        console.log(`  - Selling plan ID:`, node.sellingPlanAllocation?.sellingPlan?.id);
        console.log(`  - Selling plan Name:`, node.sellingPlanAllocation?.sellingPlan?.name);
      });
    }
    console.groupEnd();
  },

  verifyCheckout(cart) {
    console.group('🛒 Pre-Checkout Verification');
    cart.lines?.forEach((line, idx) => {
      if (line.sellingPlanAllocation) {
        console.log(`Line ${idx + 1}: ${line.merchandise?.product?.title}`);
        console.log('  Selling Plan:', line.sellingPlanAllocation.sellingPlan);
        const frequency = line.attributes?.find(a => a.key === '_frequency')?.value;
        console.log('  Expected Frequency:', frequency);
        console.log('  Actual Plan Name:', line.sellingPlanAllocation.sellingPlan?.name);
        
        // Check if they match
        const planName = line.sellingPlanAllocation.sellingPlan?.name || '';
        if (frequency && !planName.includes(frequency)) {
          console.error(`  ⚠️ MISMATCH: Expected ${frequency} days but got "${planName}"`);
        }
      }
    });
    console.groupEnd();
  }
};